// Within this much of 1:1 an image counts as square rather than leaning
// either way, so near-square crops don't flip the layout.
const SQUARE_TOLERANCE = 0.05

export function aspectRatio({ width, height } = {}) {
  return width && height ? width / height : null
}

// 'landscape' | 'portrait' | 'square', or null when Shopify didn't send dimensions.
export function orientation(image) {
  const ratio = aspectRatio(image)
  if (!ratio) return null
  if (Math.abs(ratio - 1) <= SQUARE_TOLERANCE) return 'square'
  return ratio > 1 ? 'landscape' : 'portrait'
}
